// eslint-disable-next-line @woocommerce/dependency-group
import './style.scss';

/**
 * SmartCare Backend JS
 *
 * Licensed under the GPLv2+ license.
 */
jQuery(document).ready(function ($) {
    'use strict';

    $.onwpFrontend = {
        /**
         * Initialize hooks and functions
         */
        init() {
        },
    };

    // Initialize
    $.onwpFrontend.init();
});
